import axios from 'axios';
import { Toast } from 'vant';
import router from '../router';
import { logoutClear, getCookie } from "../common/js";
// axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '//guo.k618.cn:8086' : '//cypoidbapi.k618.cn'
// axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '//yue.k618.cn:8086' : '//cypoidbapi.k618.cn'
axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '//localhost:8086' : '//cypoidbapi.k618.cn'

axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers['accessToken'] = localStorage.getItem('dsj_accessToken') || ''

// axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求发前拦截，header中添加token
axios.interceptors.request.use(res => {
  const { params} = res;
  /** 兼容后台管理查看审核 */
  if (params && params.isadmin && params.isadmin == 1) {
    let accessToken =  getCookie("accessToken")
    res.headers.common['platform'] = 'admin'
    res.headers.accessToken = accessToken
  }
  return res;
});

// 接收拦截
axios.interceptors.response.use(res => {
  if (typeof res.data !== 'object') {
    Toast.fail('服务端异常！')
    return Promise.reject(res)
  }
  if (res.data.code != 10000) {
    if (res.data.message) Toast.fail(res.data.message)
    // 20004、20003 一个表示token无效和失效
    if (res.data.code == 20004 || res.data.code == 20003) {
      router.push({ path: '/login' })
    }
    return Promise.reject(res.data)
  }
  return res.data
}, error => {
  console.log(' error.respons', error)
  const data = error.response.data
  if (data.message) Toast.fail(data.message)
  if (data.code == 20004 || data.code == 20003) {
    logoutClear()
    router.push({ path: '/login' })
  }
  return Promise.reject(data)
})

export default axios
